export enum PatientQueryKeys {
  PatientLogin = 'PatientLogin',
  PatientLogout = 'PatientLogout',
  PatientPasswordReset = 'PatientPasswordReset',
}
